export default __webpack_public_path__ + "static/media/dinersclub.2a0e3217.svg";